import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, TabContent, TabPane, Nav, NavItem, NavLink, Button, FormGroup, InputGroup, Input, InputGroupAddon, InputGroupText } from 'reactstrap';
import classnames from 'classnames';
import { uploadFile, getDivisions } from '../../API';
import LoadingSVG from '../../icons/Spinner-1s-200px.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import ImportAccounts from './ImportAccounts';
import ImportFees from './ImportFees';
import ClearFees from './ClearFees';


function Import(props) {
    const [activeTab, setActiveTab] = useState('accounts');

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    return (
        <div id="import">
            <Row className="title-row">
                <Col>
                    <h1>Import</h1>
                </Col>
            </Row>
            <Row className="tabs-row">
                <Col>
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'accounts' })}
                                onClick={() => { toggle('accounts'); }}>
                                Accounts
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'fees' })}
                                onClick={() => { toggle('fees'); }}>
                                Fees
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'clear' })}
                                onClick={() => { toggle('clear'); }}>
                                Clear Fees
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Col>
            </Row>
            <Row className="tab-content-row">
                <Col>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="accounts">
                            <ImportAccounts />
                        </TabPane>
                        <TabPane tabId="fees">
                            <ImportFees />
                        </TabPane>
                        <TabPane tabId="clear">
                            <ClearFees />
                        </TabPane>
                    </TabContent>
                </Col>
            </Row>
        </div>
    );
}

export default Import;